import { DiscountListItemDto } from "app/shared/model/DiscountListItemDto";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export interface DiscountListFilters {
    showAll?: boolean;
    types?: string[];
    schoolIds?: string[];
    sortOrder?: string;
}

const TYPE_TO_INT: Record<string, number> = {
    MarketDiscount: 0,
    SpecialOffer: 1,
    Promo: 2,
};

const SORT_TO_INT: Record<string, number> = {
    Alphabetical: 0,
    RecentlyAdded: 1,
    RecentlyUpdated: 2,
};

export async function getDiscountList(divisionId?: number, filters?: DiscountListFilters): Promise<DiscountListItemDto[]> {
    const localApi = await getLocalApi();
    const base = apiConfig.discounts_get_list;

    const params = new URLSearchParams();
    if (typeof divisionId === "number" && divisionId > 0) {
        params.append("divisionId", String(divisionId));
    }
    if (filters?.showAll) {
        params.append("showAll", "true");
    }
    filters?.types?.forEach(t => {
        const intVal = TYPE_TO_INT[t];
        if (intVal !== undefined) params.append("types", String(intVal));
    });
    filters?.schoolIds?.forEach(s => params.append("schoolIds", s));
    if (filters?.sortOrder) {
        const intVal = SORT_TO_INT[filters.sortOrder] ?? 0;
        params.append("sortOrder", String(intVal));
    }

    const query = params.toString();
    const url = query ? `${base}?${query}` : base;

    return await localApi.fetchList(
        url,
        mapDiscountListResult,
        'Error fetching discount list'
    );
}

function mapDiscountListResult(dto: any) {
    return dto as DiscountListItemDto;
}